export default {
    "restore-all-materials": "Restore all materials",
    "from-the-selected-medical-rep-to-your-account": "from the selected medical rep to your account",
    "materials-summary": "Materials Summary",
    "remaining-materials": "Remaining materials"
}